import React from 'react';
import { GridLegacy as Grid, Typography, ListItem, List, ListItemText } from '@mui/material';

const DATA = {
  PUBLISHED: (
    <>
      <Typography>
        When Equipment and Points are published in the Staging Area they become part of the building
        model.
      </Typography>
      <List sx={{ listStyleType: 'disc' }}>
        <ListItem>
          <ListItemText sx={{ display: 'list-item' }}>
            Published Equipment and Points are visible in the Explore Page.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText sx={{ display: 'list-item' }}>
            Published equipment can be assigned relationships such as CONTAINs and FEEDs
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText sx={{ display: 'list-item' }}>
            Published points have streaming time-series data.
          </ListItemText>
        </ListItem>
      </List>
    </>
  ),
  'PARTIALLY PUBLISHED': (
    <Typography>
      An Equipment with Points where some of the Points are published and some of the Points are not
      published.
    </Typography>
  ),
  UNPUBLISHED: (
    <Typography>
      Unpublished Equipment and Points in the Staging Area are waiting to be modeled.
    </Typography>
  ),
};

const ModelingState = ({ attr }) => (
  <div className="leaf location">
    <Typography variant="h5" className="name">
      {attr}
    </Typography>

    <Grid item xs={2}>
      <Typography variant="h6">Description:</Typography>
    </Grid>
    <Grid item xs={8} className="static-attr">
      <p>{DATA[attr]}</p>
    </Grid>
  </div>
);

export default ModelingState;
